import vase from "../../images/vase.webp";
import HomeName from "../../images/HomeName.webp";
import styles from "./Home.module.css";
import useImageProtection from "../../hooks/useImageProtection";
import HomeShowcaseSection from "../../components/HomeShowcaseSection/HomeShowcaseSection";
import ReviewsSection from "../../components/ReviewSection/ReviewSection";

const Home = () => {
  useImageProtection();

  return (
    <>
      <div className={styles.homeWrapper}>
        <img
          src={HomeName}
          alt="Marléna Mendoza"
          className={styles.homeNameImage}
        />
        <img src={vase} alt="Vase artwork" className={styles.heroImage} />
      </div>
      <HomeShowcaseSection />
      <ReviewsSection />
    </>
  );
};

export default Home;
